import { PopularDestinations } from 'shared/seo/PopularDestinations';
import { InternalLinksSection } from '@/components/internalLinks/InternalLinksSection';
import prepackage from '@/components/internalLinks/prepackage.json';
import { transformDestinations } from '@/components/internalLinks/transformDestinations';
import carRentalData from './data/carrental.json';
import data from './data/pp.json';
import { toDestinations } from './toDestinations';

export const PrepackageSeo = () => {
    const prepackageItems = transformDestinations(prepackage, 'pakkereiser');

    const countries = toDestinations(data.countries, data.cdnPath, data.basePath, data.altPrefix);
    const restplasser = data.restplasser.map((dest) => ({
        image: `${data.cdnPath}${dest.image}.jpg`,
        label: dest.label,
        alt: dest.label,
        href: dest.href,
    }));
    const carRentalCountries = toDestinations(
        carRentalData.countries,
        carRentalData.cdnPath,
        carRentalData.basePath,
        carRentalData.altPrefix,
    );

    return (
        <>
            <PopularDestinations id="seo-pp-countries" heading={data.countriesHeading} destinations={countries} />
            <InternalLinksSection
                title="Finn pakkereiser til spennende steder"
                titleId="seo-pp-to-exciting-places"
                items={prepackageItems}
            />
            <PopularDestinations id="seo-restplasser" heading="Se de beste restplasstilbudene på FINN" destinations={restplasser} />
            <PopularDestinations id="seo-pp-carrental" heading={carRentalData.countriesHeading} destinations={carRentalCountries} />
        </>
    );
};
